module.exports = __webpack_public_path__ + "ad39895f25759d954902d5780677ff.png";